/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InitiativeForm from '../../InitiativeForm/InitiativeForm';
import './Initiative.scss';

export default function Initiative() {
  const { t } = useTranslation('personal_account', { keyPrefix: 'initiative' });

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const initiative = document.querySelector('.Initiative');
    const footer = document.querySelector('.Footer');
    const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);

    initiative.style.minHeight = `${minimumRequiredHeight}px`;
  }, []);

  return (
    <section className="Initiative">
      <div className="wrapper">
        <div className="initiative-content">
          <h1 className="heading-one">
            {t('heading')}
          </h1>
          <InitiativeForm />
        </div>
      </div>
    </section>
  );
}
